"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Username = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var verified_badge_1 = __importDefault(require("./verified-badge"));
exports.Username = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: white;\n    font-size: 16px;\n    font-weight: 700;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    -webkit-font-smoothing: antialiased;\n"], ["\n    color: white;\n    font-size: 16px;\n    font-weight: 700;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    -webkit-font-smoothing: antialiased;\n"])));
var VerifiedBadge = (0, styled_1.default)(verified_badge_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-left: 4px;\n    flex-shrink: 0;\n"], ["\n    margin-left: 4px;\n    flex-shrink: 0;\n"])));
var Container = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    min-width: 0;\n"], ["\n    display: flex;\n    align-items: center;\n    min-width: 0;\n"])));
var User = function (_a) {
    var user = _a.user;
    var display_name = user.display_name, username = user.username;
    return (react_1.default.createElement(Container, null,
        react_1.default.createElement(exports.Username, null, display_name || "@".concat(username)),
        user.is_verified ? react_1.default.createElement(VerifiedBadge, { size: 14 }) : null));
};
exports.default = User;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=user.js.map